/**
 * Logout langsung tanpa dialog - untuk kasus akun dinonaktifkan oleh admin
 * Fungsi mandiri, tidak memakai AuthAction/logoutUser/prosedur logout umum
 */

import { API_ESA_OFFICE } from "./index";

const FORCE_LOGOUT_FLAG = "force_logout_inactive";

export function forceLogoutInactive() {
  // Flag agar logoutUser tidak menampilkan dialog jika masih terpanggil
  sessionStorage.setItem(FORCE_LOGOUT_FLAG, "1");

  localStorage.removeItem("user");
  localStorage.removeItem("accessToken");
  localStorage.removeItem("daftarHadir");

  fetch(`${API_ESA_OFFICE}users/logout`, {
    method: "DELETE",
    credentials: "include",
  }).catch(() => {});

  window.location.hash = "#/authentication/sign-in/cover";
}

export function isForceLogoutInProgress() {
  return sessionStorage.getItem(FORCE_LOGOUT_FLAG) === "1";
}
